import * as React from "react";
import {useEffect} from "react";
import {IPlanCashFlow, PortfolioApi} from "../../api/PortfolioApi";
import {IRangeValue} from "../../api/InFormReportingApi";
import {formatShortDate} from "../../utils/dateUtil";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import {getNumber} from "../../utils/commonUtil";
import {IPlanMarketValueLineChart, PlanMarketValueLineChart} from "./PlanMarketValueLineChart";
import {PlanCashFlowBarChart} from "./PlanCashFlowBarChart";
import {IHorizontalBarChart} from "../common/HorizontalBarChart.component";

export const FinancialReconciliationTab: React.FunctionComponent = () => {
    const [planMarketValues, setPlanMarketValues] = React.useState<IPlanMarketValueLineChart[]>([]);
    const [planCashFlows, setPlanCashFlows] = React.useState<IHorizontalBarChart[]>([]);
    const [loading, setLoading] = React.useState<boolean>(true);

    const getPlanMarketValueData = (productData: IRangeValue[]): IPlanMarketValueLineChart[] => {
        return productData
            .map((productValue: IRangeValue) => {
                return {
                    asOfDate: formatShortDate(productValue.date),
                    value: getNumber(productValue.value)
                };
            });

    };
    
    const getPlanCashFlowData = (productData: IPlanCashFlow[]): IHorizontalBarChart[] => {
        return productData
            .map((productValue: IPlanCashFlow) => {
                return {
                    label: formatShortDate(productValue.date),
                    value: getNumber(productValue.netCashFlow)
                };
            }); 
    };

    useEffect(() => {
        PortfolioApi.getCurrentPlanMarketValues()
            .then(response => {
                const formatedResponse = getPlanMarketValueData(response);
                setPlanMarketValues(formatedResponse);
                setLoading(false);
            }).catch(() => setLoading(false));
    }, []);

    useEffect(() => {
        PortfolioApi.getCurrentPlanCashFlow()
            .then(response => {
                const formatedResponse = getPlanCashFlowData(response);
                setPlanCashFlows(formatedResponse);
                setLoading(false);
            }).catch(() => setLoading(false));
    }, []);

    if(loading) {
        return <LoadingSpinner/>;
    }

    return <div className="financial-reconciliation-tab__container"
                data-testid="financial-reconciliation-tab__container">
        {planMarketValues.length > 0 && <PlanMarketValueLineChart planMarketValues={planMarketValues}/>}
        {planCashFlows.length > 0 && <PlanCashFlowBarChart data={planCashFlows}/>}
    </div>;
};
